import React from 'react';

const OnboardingHeader = ({ step, totalSteps = 3 }) => {
  const progress = (step / totalSteps) * 100;

  return (
    <header className="relative w-full bg-gradient-to-r from-blue-700 to-indigo-900 shadow-sm border-b border-indigo-800/50">
      {/* Subtle top glare for a premium UI feel */}
      <div className="absolute top-0 inset-x-0 h-[1px] bg-white/10"></div>

      {/* Tighter padding (py-5) for a professional, slim header */}
      <div className="max-w-5xl mx-auto px-6 py-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">

        {/* Left Side: Brand & Exact Step */}
        <div className="flex items-center gap-4">
          {/* Logo container: Fixed size and perfectly centered */}
          <div className="bg-white w-11 h-11 rounded-xl flex items-center justify-center shadow-md p-1.5 shrink-0">
            <img 
              src="/logo.png" 
              alt="CampusIRA" 
              className="w-full h-full object-contain" 
            />
          </div>

          <div className="flex flex-col justify-center">
            <h1 className="text-lg font-bold text-white tracking-tight leading-tight">
              CampusIRA
            </h1>
            <div className="flex items-center gap-1.5 text-[11px] font-medium text-blue-200 mt-0.5">
              <span className="uppercase tracking-wider">Step {step} of {totalSteps}</span>
              <span className="w-1 h-1 rounded-full bg-blue-400/60"></span>
              <span>Profile Setup</span>
            </div>
          </div>
        </div>

        {/* Right Side: Minimal Information Line (Hidden on tiny phones, visible on standard screens) */}
        <div className="hidden md:flex items-center bg-white/5 backdrop-blur-sm border border-white/10 rounded-full px-5 py-2">
          <p className="text-xs font-medium text-blue-100 flex items-center gap-2">
            Personalizing your experience for
            <span className="font-bold text-white">Interview Insights</span>
            <span className="text-blue-400/50">•</span>
            <span className="font-bold text-white">Campus Feed</span>
          </p>
        </div>

      </div>

      {/* Clean, 2px Progress Line exactly on the bottom border */}
      <div className="absolute bottom-0 left-0 w-full h-[2px] bg-indigo-950/50">
        <div 
          className="h-full bg-blue-400 transition-all duration-700 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </header>
  );
};

export default OnboardingHeader;